var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"class"},[_c('p',[_c('pre',{staticClass:"h5"},[_vm._v(_vm._s(_vm.myProduct.description))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }